export default function TitleBlock({ eyebrow, title, subtitle, right }) {
  return (
    <div className="title-block flex flex-col md:flex-row md:items-end md:justify-between gap-4" data-testid="title-block">
      <div>
        {eyebrow && (
          <div className="text-yellow text-xs tracking-[0.28em] uppercase mb-2">{eyebrow}</div>
        )}
        <h1 className="text-3xl md:text-4xl font-bold tracking-tight text-warm">{title}</h1>
        {subtitle && <p className="mt-2 text-sm md:text-base text-warm opacity-80 max-w-2xl">{subtitle}</p>}
      </div>
      {right && <div className="flex items-center gap-3">{right}</div>}
    </div>
  );
}
